'use client';

import { useEffect } from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log critical errors that break the entire app
    console.error('CRITICAL Global Error:', {
      message: error.message,
      stack: error.stack,
      digest: error.digest,
      name: error.name,
      timestamp: new Date().toISOString(),
    });
  }, [error]);

  return (
    <html>
      <body>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            fontFamily: 'system-ui, sans-serif',
            padding: '20px',
          }}
        >
          <h1>Critical Application Error</h1>
          <p>A critical error occurred. Please check the browser console.</p>

          {process.env.NODE_ENV === 'development' && (
            <pre
              style={{
                background: '#f5f5f5',
                padding: '20px',
                borderRadius: '8px',
                overflow: 'auto',
                maxWidth: '800px',
                fontSize: '12px',
              }}
            >
              {error.message}
              {'\n\n'}
              {error.stack}
            </pre>
          )}

          <button
            onClick={reset}
            style={{
              marginTop: '20px',
              padding: '10px 20px',
              fontSize: '16px',
              cursor: 'pointer',
              background: '#0070f3',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
            }}
          >
            Try Again
          </button>

          {error.digest && (
            <p style={{ marginTop: '20px', fontSize: '12px', color: '#666' }}>
              Error ID: {error.digest}
            </p>
          )}
        </div>
      </body>
    </html>
  );
}
